import ClipboardJS from 'clipboard'

const initCopyButtons = (wrapperEl) => {
  const buttons = wrapperEl.querySelectorAll('[data-bhub-copy-button]')

  if (buttons) {
    buttons.forEach((button) => {
      const icon = button.querySelector('i')
      const currentClass = icon.getAttribute('class')

      const clipboard = new ClipboardJS(button, {
        text: function () {
          return button.getAttribute('data-id')
        },
      })

      clipboard.on('success', function () {
        icon.setAttribute('class', 'bhub-icons-check')
        setTimeout(() => {
          icon.setAttribute('class', currentClass)
        }, 2000)
      })
    })
  }
}

export default initCopyButtons
